// Storage.prototype.set = (key, value) => window.localStorage.setItem(key, JSON.stringify(value));
// Storage.prototype.get = key => JSON.parse(window.localStorage.getItem(key));
// Storage.prototype.remove = key => window.localStorage.removeItem(key);

export const translatedLocalStorageKeys = {
  newUserInfo: 'newUserInfo@translated.com',
  currentUserToken: 'currentUserToken@translated.com',
  selectedQuote: 'selectedQuote@translated.com',
  selectedQuoteCreation: 'selectedQuoteCreation@translated.com',
  projectInfo: 'projectInfo@translated.com',
  projectInfoCreation: 'projectInfoCreation@translated.com',
  currentOrder: 'currentOrder@translated.com',
  selectedCurrency: 'selectedCurrency@translated.com',
  instantQuoteSourceLanguage: 'instantQuoteSourceLanguage@translated.com',
  instantQuoteTargetLanguages: 'instantQuoteTargetLanguages@translated.com',
  instantQuoteSubject: 'instantQuoteSubject@translated.com',
  instantQuoteDelivery: 'instantQuoteDelivery@translated.com',
  instantQuoteDeliveryCreation: 'instantQuoteDeliveryCreation@translated.com',
  instantQuoteWords: 'instantQuoteWords@translated.com',
  instantQuoteWordsCreation: 'instantQuoteWordsCreation@translated.com',
  instantQuoteDefault: 'instantQuoteDefault@translated.com',
  stats: 'stats@translated.com',
  hb_storeInstantQuote: 'hb_instantQuotes@translated.com',
  hbapi_instantQuotes: 'hbapi_instantQuotes@translated.com',
}

const translatedSessionStorageKeys = {
  currentTimezone: 'currentTimezone@translated.com',
}

export const sessionStoreCurrentTimezone = (timezone) =>
  sessionStorage.setItem(
    translatedSessionStorageKeys.currentTimezone,
    JSON.stringify(timezone),
  )

export const sessionGetCurrentTimezone = () => {
  try {
    const currentTimezone = sessionStorage.getItem(
      translatedSessionStorageKeys.currentTimezone,
    )

    if (currentTimezone) return JSON.parse(currentTimezone)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const storeInstantQuoteSourceLanguage = (language) =>
  window.localStorage.setItem(
    translatedLocalStorageKeys.instantQuoteSourceLanguage,
    JSON.stringify(language),
  )

export const getInstantQuoteSourceLanguage = () => {
  try {
    const instantQuoteSourceLanguage = window.localStorage.getItem(
      translatedLocalStorageKeys.instantQuoteSourceLanguage,
    )
    if (instantQuoteSourceLanguage)
      return JSON.parse(instantQuoteSourceLanguage)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const storeInstantQuoteTargetLanguages = (languages) =>
  window.localStorage.setItem(
    translatedLocalStorageKeys.instantQuoteTargetLanguages,
    JSON.stringify(languages),
  )

export const getInstantQuoteTargetLanguages = () => {
  try {
    const instantQuoteTargetLanguages = window.localStorage.getItem(
      translatedLocalStorageKeys.instantQuoteTargetLanguages,
    )
    if (instantQuoteTargetLanguages)
      return JSON.parse(instantQuoteTargetLanguages)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const storeInstantQuoteSubject = (subject) =>
  window.localStorage.setItem(
    translatedLocalStorageKeys.instantQuoteSubject,
    JSON.stringify(subject),
  )

export const getInstantQuoteSubject = () => {
  try {
    const instantQuoteSubject = window.localStorage.getItem(
      translatedLocalStorageKeys.instantQuoteSubject,
    )
    if (instantQuoteSubject) return JSON.parse(instantQuoteSubject)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const storeInstantQuoteDelivery = (delivery) => {
  window.localStorage.setItem(
    translatedLocalStorageKeys.instantQuoteDelivery,
    JSON.stringify(delivery),
  )
  window.localStorage.setItem(
    translatedLocalStorageKeys.instantQuoteDeliveryCreation,
    JSON.stringify(Date.now()),
  )
}

export const getInstantQuoteDelivery = () => {
  try {
    const instantQuoteDelivery = window.localStorage.getItem(
      translatedLocalStorageKeys.instantQuoteDelivery,
    )
    if (instantQuoteDelivery) return JSON.parse(instantQuoteDelivery)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const removeInstantQuoteDelivery = () => {
  window.localStorage.removeItem(
    translatedLocalStorageKeys.instantQuoteDelivery,
  )
  window.localStorage.removeItem(
    translatedLocalStorageKeys.instantQuoteDeliveryCreation,
  )
}

export const storeInstantQuoteWords = (words) => {
  window.localStorage.setItem(
    translatedLocalStorageKeys.instantQuoteWords,
    `${words}`,
  )
  window.localStorage.setItem(
    translatedLocalStorageKeys.instantQuoteWordsCreation,
    JSON.stringify(Date.now()),
  )
}

export const getInstantQuoteWords = () => {
  const instantQuoteWords = window.localStorage.getItem(
    translatedLocalStorageKeys.instantQuoteWords,
  )
  const words = parseInt(instantQuoteWords)
  if (instantQuoteWords && !isNaN(words)) return words
}

export const getInstantQuoteWordsCreation = () => {
  try {
    return JSON.parse(
      window.localStorage.getItem(
        translatedLocalStorageKeys.instantQuoteWordsCreation,
      ),
    )
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const storeFirstQuoteProjectId = (projectId) => {
  // Always overwrite: each time a quote is selected, it becomes the new "first quote"
  window.localStorage.setItem(
    translatedLocalStorageKeys.firstQuoteProjectId,
    JSON.stringify(projectId),
  )
}

export const removeInstantQuoteWords = () => {
  window.localStorage.removeItem(translatedLocalStorageKeys.instantQuoteWords)
  window.localStorage.removeItem(
    translatedLocalStorageKeys.instantQuoteWordsCreation,
  )
}

export const getInstantQuoteDeliveryCreation = () => {
  try {
    return JSON.parse(
      window.localStorage.getItem(
        translatedLocalStorageKeys.instantQuoteWordsCreation,
      ),
    )
  } catch (error) {
    console.error(error)
  }
}

export const storeSelectedQuote = (quote) =>
  window.localStorage.setItem(
    translatedLocalStorageKeys.selectedQuote,
    JSON.stringify(quote),
  )

export const hb_storeInstantQuote = (quoteCode, quote) => {
  try {
    let hb_instantQuotes = JSON.parse(
      window.localStorage.getItem(
        translatedLocalStorageKeys.hb_storeInstantQuote,
      ) || '{}',
    )
    let pair = {[quoteCode]: quote} //Note: [quoteCode] use the value of the variable as key instead of the 'quoteCode' string
    hb_instantQuotes = {...hb_instantQuotes, ...pair}
    localStorage.setItem(
      translatedLocalStorageKeys.hb_storeInstantQuote,
      JSON.stringify(hb_instantQuotes),
    )
  } catch (error) {
    console.error(error)
  }
}
export const hb_getAllInstantQuote = () => {
  try {
    const hb_instantQuotes = JSON.parse(
      window.localStorage.getItem(
        translatedLocalStorageKeys.hb_storeInstantQuote,
      ) || '{}',
    )
    Object.values(hb_instantQuotes).forEach((quote) => {
      if (
        quote.deliveryDate &&
        quote.deliveryDate.date &&
        !quote.deliveryDate.isAuto
      )
        quote.deliveryDate.date = new Date(quote.deliveryDate.date)
    })
    return hb_instantQuotes
  } catch (error) {
    console.error(error)
  }
}
export const hb_deleteInstantQuote = (quoteCode) => {
  try {
    const hb_instantQuotes = JSON.parse(
      window.localStorage.getItem(
        translatedLocalStorageKeys.hb_storeInstantQuote,
      ) || '{}',
    )
    delete hb_instantQuotes[quoteCode]
    window.localStorage.setItem(
      translatedLocalStorageKeys.hb_storeInstantQuote,
      JSON.stringify(hb_instantQuotes),
    )
    return !(quoteCode in hb_instantQuotes)
  } catch (error) {
    console.error(error)
  }
}

export const hbapi_storeInstantQuote = (quoteCode, quote) => {
  try {
    let hbapi_instantQuotes = JSON.parse(
      window.localStorage.getItem(
        translatedLocalStorageKeys.hbapi_instantQuotes,
      ) || '{}',
    )
    let pair = {[quoteCode]: quote} //Note: [quoteCode] use the value of the variable as key instead of the 'quoteCode' string
    hbapi_instantQuotes = {...hbapi_instantQuotes, ...pair}
    localStorage.setItem(
      translatedLocalStorageKeys.hbapi_instantQuotes,
      JSON.stringify(hbapi_instantQuotes),
    )
  } catch (error) {
    console.error(error)
  }
}
export const hbapi_updateInstantQuote = (quoteCode, partialQuote) => {
  try {
    let hbapi_instantQuotes = JSON.parse(
      window.localStorage.getItem(
        translatedLocalStorageKeys.hbapi_instantQuotes,
      ) || '{}',
    )
    const current = hbapi_instantQuotes[quoteCode]
    let pair = {[quoteCode]: {...current, ...partialQuote}}
    hbapi_instantQuotes = {...hbapi_instantQuotes, ...pair}
    localStorage.setItem(
      translatedLocalStorageKeys.hbapi_instantQuotes,
      JSON.stringify(hbapi_instantQuotes),
    )
  } catch (error) {
    console.error(error)
  }
}
export const hbapi_getAllInstantQuote = () => {
  try {
    const hbapi_instantQuotes = JSON.parse(
      window.localStorage.getItem(
        translatedLocalStorageKeys.hbapi_instantQuotes,
      ) || '{}',
    )
    Object.values(hbapi_instantQuotes).forEach((quote) => {
      if (
        quote.deliveryDate &&
        quote.deliveryDate.date &&
        !quote.deliveryDate.isAuto
      )
        quote.deliveryDate.date = new Date(quote.deliveryDate.date)
    })
    return hbapi_instantQuotes
  } catch (error) {
    console.error(error)
  }
}
export const hbapi_deleteInstantQuotes = () => {
  try {
    window.localStorage.removeItem(
      translatedLocalStorageKeys.hbapi_instantQuotes,
    )
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const getSelectedQuote = () => {
  try {
    const selectedQuote = window.localStorage.getItem(
      translatedLocalStorageKeys.selectedQuote,
    )
    if (selectedQuote) {
      const storedQuote = JSON.parse(selectedQuote)
      return Object.assign(storedQuote, {
        deliveryDate: new Date(storedQuote.deliveryDate),
      })
    }
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const storeProjectInfo = (projectInfo) => {
  window.localStorage.setItem(
    translatedLocalStorageKeys.projectInfo,
    JSON.stringify(projectInfo),
  )
  window.localStorage.setItem(
    translatedLocalStorageKeys.projectInfoCreation,
    JSON.stringify(Date.now()),
  )
}

export const getProjectInfo = () => {
  try {
    const projectInfo = window.localStorage.getItem(
      translatedLocalStorageKeys.projectInfo,
    )
    if (projectInfo) return JSON.parse(projectInfo)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const getProjectInfoCreation = () => {
  try {
    return JSON.parse(
      window.localStorage.getItem(
        translatedLocalStorageKeys.projectInfoCreation,
      ),
    )
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const clearProjectInfo = () => {
  window.localStorage.removeItem(translatedLocalStorageKeys.projectInfo)
  window.localStorage.removeItem(translatedLocalStorageKeys.projectInfoCreation)
}

export const storeNewUserInfo = (userInfo) => {
  const userInfoCleanPassword = Object.assign({}, userInfo, {password: ''})
  window.localStorage.setItem(
    translatedLocalStorageKeys.newUserInfo,
    JSON.stringify(userInfoCleanPassword),
  )
}

export const getNewUserInfo = () => {
  try {
    const userInfo = window.localStorage.getItem(
      translatedLocalStorageKeys.newUserInfo,
    )
    if (userInfo) return JSON.parse(userInfo)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const clearNewUserInfo = () =>
  window.localStorage.getItem(translatedLocalStorageKeys.newUserInfo)

export const storeCurrentUserToken = (userToken) =>
  window.localStorage.setItem(
    translatedLocalStorageKeys.currentUserToken,
    userToken,
  )

export const getCurrentUserToken = () =>
  window.localStorage.getItem(translatedLocalStorageKeys.currentUserToken)

export const clearCurrentUserToken = () => {
  window.localStorage.removeItem(translatedLocalStorageKeys.currentUserToken)
  window.localStorage.removeItem('token')
}

export const storeCurrentOrder = (order) =>
  window.localStorage.setItem(
    translatedLocalStorageKeys.currentOrder,
    JSON.stringify(order),
  )

export const getCurrentOrder = () => {
  try {
    const order = window.localStorage.getItem(
      translatedLocalStorageKeys.currentOrder,
    )
    if (order) return JSON.parse(order)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const storeSelectedCurrency = (selectedCurrency) =>
  window.localStorage.setItem(
    translatedLocalStorageKeys.selectedCurrency,
    JSON.stringify(selectedCurrency),
  )

export const getSelectedCurrency = () => {
  try {
    const selectedCurrency = window.localStorage.getItem(
      translatedLocalStorageKeys.selectedCurrency,
    )
    if (selectedCurrency) return JSON.parse(selectedCurrency)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const storeInstantQuoteDefault = (instantQuoteDefault) =>
  window.localStorage.setItem(
    translatedLocalStorageKeys.instantQuoteDefault,
    JSON.stringify(instantQuoteDefault),
  )

export const getInstantQuoteDefault = () => {
  try {
    const instantQuoteDefault = window.localStorage.getItem(
      translatedLocalStorageKeys.instantQuoteDefault,
    )
    if (instantQuoteDefault) return JSON.parse(instantQuoteDefault)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const clearInstantQuoteDefault = () =>
  window.localStorage.removeItem(translatedLocalStorageKeys.instantQuoteDefault)

export const storeStats = (stats) =>
  window.localStorage.setItem(
    translatedLocalStorageKeys.stats,
    JSON.stringify(stats),
  )

export const getStats = () => {
  try {
    const stats = window.localStorage.getItem(translatedLocalStorageKeys.stats)
    if (stats) return JSON.parse(stats)
  } catch (error) {
    console.error('storage.js error', error)
  }
}

export const clearStats = () =>
  window.localStorage.removeItem(translatedLocalStorageKeys.stats)

const SWORN_ORDER_PENDING_KEY = 'swornOrderPending@translated.com'
const SELECTED_SWORN_QUOTE_KEY = 'selectedSwornQuote@translated.com'

export const storeSwornOrderPending = (data) =>
  window.localStorage.setItem(SWORN_ORDER_PENDING_KEY, JSON.stringify(data))

export const getSwornOrderPending = () => {
  try {
    const raw = window.localStorage.getItem(SWORN_ORDER_PENDING_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const clearSwornOrderPending = () => {
  window.localStorage.removeItem(SWORN_ORDER_PENDING_KEY)
  window.localStorage.removeItem(SELECTED_SWORN_QUOTE_KEY)
}
